import React, { useState } from "react";
import Close from "@material-ui/icons/Close";
import Form from "../../Sections/FormSection/Form";
import FormModal from "../../Sections/FormSection/FormModal";
import FormData from "../../Sections/FormSection/FormData";
import "../../Sections/FormSection/FormSection.css";
function ServiceForms(props) {
  const [showFormModal, setShowFormModal] = useState(false);
  const [modalData, setModalData] = useState();
  const ModalData = (data) => {
    setModalData(data);
  };
  const handleFormModal = (state) => {
    setShowFormModal(state);
  };
  return (
    <div className={`${props.mobileVersion ? "mt-0" : "blogdiv"} `}>
      <div
        className={`d-flex withfilter ${props.mobileVersion ? "p-0" : "p-2"}`}
      >
        {!props.mobileVersion && (
          <>
            {" "}
            <Close
              onClick={() => {
                props.onCloseForms();
              }}
            />
            <h2 className="mr-5">Forms</h2>{" "}
          </>
        )}
      </div>
      <div
        className={`formSection ${props.mobileVersion ? "mt-0" : ""}`}
        id="formSection"
      >
        <div className="container justify-content-center">
          <div
            className={`row forms justify-content-center ${
              props.mobileVersion ? "flex-column" : ""
            }`}
          >
            {FormData.map((form, i) => (
              <Form
                key={i}
                data={form}
                setModalData={ModalData}
                handleFormModal={handleFormModal}
              />
            ))}
          </div>
        </div>
      </div>
      {showFormModal ? (
        <FormModal
          data={modalData}
          show={showFormModal}
          handleModal={handleFormModal}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default ServiceForms;
